import React, { useEffect } from "react";
import { CheckCircle, XCircle } from "lucide-react";

interface ToastProps {
  message: string;
  isVisible: boolean;
  onClose: () => void;
  type?: "success" | "error";
}

const Toast: React.FC<ToastProps> = ({
  message,
  isVisible,
  onClose,
  type = "success",
}) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  const isError = type === "error";
  const Icon = isError ? XCircle : CheckCircle;
  const bgColor = isError ? "bg-red-500" : "bg-success";

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-fade-in">
      <div
        className={`${bgColor} text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-2 max-w-md`}
      >
        <Icon size={20} className="flex-shrink-0" />
        <span>{message}</span>
      </div>
    </div>
  );
};

export default Toast;
